/*
 * Keeps the free-delivery bar in step with the cart.
 *
 * The bar is rendered server-side so it is already correct on load; this only
 * has to react to changes made without a page reload — quick-add, the cart
 * drawer, quantity steppers. Dawn broadcasts those through its own pub/sub, so
 * we subscribe where we can and fall back to watching fetches to /cart/*.
 */
(function () {
  'use strict';

  var bar = document.querySelector('[data-pfb-ship-bar]');
  if (!bar) return;

  var textEl = bar.querySelector('[data-pfb-ship-text]');
  var fillEl = bar.querySelector('[data-pfb-ship-fill]');
  var trackEl = bar.querySelector('[data-pfb-ship-track]');
  var threshold = parseInt(bar.dataset.threshold, 10) || 0;

  function money(paise) {
    var rupees = Math.ceil(paise / 100);
    return '₹' + rupees.toLocaleString('en-IN');
  }

  function render(total) {
    var pct = threshold ? Math.min(100, Math.round((total / threshold) * 100)) : 0;
    var remaining = threshold - total;

    fillEl.style.width = pct + '%';
    trackEl.setAttribute('aria-valuenow', String(pct));
    bar.classList.toggle('pfb-ship-bar--empty', total === 0);
    bar.classList.toggle('pfb-ship-bar--unlocked', remaining <= 0);

    textEl.innerHTML = remaining > 0
      ? 'Add <strong>' + money(remaining) + '</strong> more for free delivery'
      : "You've unlocked <strong>free delivery</strong>";
  }

  function refresh() {
    fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart.total_price); })
      .catch(function () { /* leave the server-rendered state alone */ });
  }

  // Dawn's own cart events, when they're available.
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refresh);
  }

  // Anything else that posts to the cart — quick-add buttons, the drawer.
  var nativeFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var href = typeof url === 'string' ? url : (url && url.url) || '';
    var result = nativeFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(href)) {
      result.then(function () { setTimeout(refresh, 80); });
    }
    return result;
  };
})();
